import $ from 'jquery';

(function ($) {
  $(document).ready(function () {
    if ($('#add_document').length < 1) {
      return;
    }
    const leaseeCb = function (e) {
      const val = $('[name="doc[leasee]"]').val();
      if (val === 'NEW') {
        $('.styled-fieldsets', '#lessee').show();
      } else {
        $('.styled-fieldsets', '#lessee').hide();
      }
    };
    $('[name="doc[leasee]"]').change(leaseeCb);
    leaseeCb();
  })
})($);
